<!-- Start -->

<ion-grid *ngIf="data?.places?.length == 0">
  <ion-list>
    <div class="start">
      <img src="assets/svg/visual-places.svg" alt="Places" />
      <div class="text">{{ capacitor.translateString('StartPlacesText') }}</div>
      <div class="buttons">
        <ion-button mode="ios" class="primary" (click)="openSearch()">
          <ion-label>{{ capacitor.translateString('StartPlace') }}</ion-label>
        </ion-button>
      </div>
    </div>
  </ion-list>
</ion-grid>

<!-- Places -->

<ion-grid *ngIf="data && data?.places?.length != 0">
  <app-header title="Places" type="places" [edit]="true"></app-header>
  <ion-skeleton-text *ngIf="!data?.places" animated></ion-skeleton-text>
  <ion-list>
    <app-item [data]="data" *ngFor="let data of places; index as i; trackBy: ionic.trackItem"></app-item>
  </ion-list>
</ion-grid>

<!-- Infinite -->

<ion-infinite-scroll (ionInfinite)="doInfinite($event)" *ngIf="places && data?.places?.length >= 50">
  <ion-infinite-scroll-content></ion-infinite-scroll-content>
</ion-infinite-scroll>
